<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-row class="ma-0"   v-if="errors && errors.length > 0">
        <v-col cols="12">
            <v-list two-line>
                <v-list-item avatar v-for="(error, index) in errors" :key="index">
                    <v-list-item-avatar>
                        <v-icon color="error">error</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                        <v-list-item-title>{{error.message}}</v-list-item-title>
                        <v-list-item-subtitle>{{error.total}} ocurrencias</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-col>

        <v-col class="px-4" cols="12" >
            <h4>Detalles</h4>
        </v-col>

        <v-col class="pa-0" cols="12" >
            <v-divider></v-divider>
        </v-col>

        <v-col cols="12" class="pa-0">
            <v-data-table
                    :headers="headers"
                    :items="importErrors"
                    :options.sync="options"
                    :footer-props="{
                      'items-per-page-text': 'Errores por página',
                      'items-per-page-options': [50, 100, 200]
                    }"
                    :server-items-length="totalImportErrors"
                    :must-sort="false">
                <template v-slot:item="{ item }">
                  <tr>
                    <td>{{item.info.data[0]}}</td>
                    <td>{{item.error}}</td>
                    <td>{{item.info.workBook}}</td>
                    <td>{{item.info.sheet}}</td>
                    <td>{{item.info.row}}</td>
                  </tr>
                </template>
            </v-data-table>
        </v-col>
    </v-row>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      campaign: state => state.campaigns.campaign,
      importErrors: state => state.campaigns.importErrors,
      paginationImportErrors: state => state.users.paginationImportErrors,
      totalImportErrors: state => state.campaigns.totalImportErrors
    }),
    errors () {
      return this.campaign.importErrors
    }
  },
  data () {
    return {
      headers: [
        { text: 'Causa del error', sortable: false },
        { text: 'Detalle', sortable: false },
        { text: 'Libro', sortable: false },
        { text: 'Hoja', sortable: false },
        { text: 'Fila', sortable: false }
      ],
      options: {}
    }
  },
  methods: {
    getImportErrors () {
      this.$store.commit('SET_PAGINATION_IMPORT_ERRORS', { page: this.options.page, itemsPerPage: this.options.itemsPerPage, sortBy: this.options.sortBy[0], descending: this.options.sortDesc[0] })
      this.$store.dispatch('getTheErrorsGeneratedByTheUpload', { campaignId: this.$route.params.campaignid })
    }
  },
  watch: {
    options: {
      handler () {
        this.getImportErrors()
        // this.$vuetify.goTo(0, { page: this.options.page, itemsPerPage: this.options.itemsPerPage, sortBy: this.options.sortBy[0], descending: this.options.sortDesc[0] })
      },
      deep: true
    },
    search () {
      this.options.page = 1
      this.getImportErrors()
    }
  }
}
</script>
